import React from "react";
import ReactTooltip from "react-tooltip";
import PaymentIcon from "@material-ui/icons/Payment";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import DonutLargeIcon from "@material-ui/icons/DonutLarge";
import withStyles from "@material-ui/core/styles/withStyles";
import "react-toastify/dist/ReactToastify.css";
import AdditionalDetails from "./additionalDetails";
import ClaimAmount from "./amount";
import ClaimStatus from "./status";
import DownloadIcon from "./downloadIcon";
import ReUploadButton from "./reUploadButton";
import UploadButton from "./uploadButton";
import { Box, Button } from "@material-ui/core";
import { StyledTableRow, StyledTableCell, useStyles } from "./styles";
import {
  BUTTON_COPAY,
  BUTTON_ESTIMATE_CLAIM,
  BUTTON_PAYMENT_LINK,
  BUTTON_PAYMENT_PENDING,
  BUTTON_UPLOAD_DAMAGED_MOBILE,
  BUTTON_UPLOAD_INVOICE,
  BUTTON_UPLOAD_REPAIRED_MOBILE,
  CLAIM_STATUS_APPROVED_SLUG,
  CLAIM_STATUS_INITIATED_SLUG,
  CLAIM_STATUS_PARTIALLY_APPROVED,
  CLAIM_STATUS_REJECTED_SLUG,
  DOCUMENT_TPYE_ID_MOBILE_PHOTOS,
  DOCUMENT_TPYE_ID_ESTIMATE,
  DOCUMENT_TPYE_ID_INVOICE,
  DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS,
  FORMAT_DD_MM_YYYY,
  PENDING_TEXT,
  SLUG_DAMAGED_MOBILE,
  SLUG_ESTIMATE_MOBILE,
  SLUG_INVOICE_MOBILE,
  SLUG_REPAIRED_MOBILE,
  UPLOAD_REPAIRED_INVOICE_PHOTO,
  UPLOAD_REPAIRED_MOBILE_PHOTO,
} from "../../constants/index";
import {
  getServiceCentreDetails,
  isCopaymentSkippedForClaim,
} from "../../helpers/proposal";
import { convertDateTimeFormat } from "../../helpers/date";

function ListItem({
  classes: { borderRadius, capitalize, marginLeft, preferredClaim, timeslot },
  classes,
  downloadFile,
  handleEstimateClick,
  handlePaymentLinkClick,
  handleRemarksClick,
  index,
  item,
  uploadClickHandler,
}) {
  return (
    <StyledTableRow name="row" key={index} className={""}>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {getServiceCentreDetails() == item.service_centre_id && (
          <Box className={preferredClaim}>
            {convertDateTimeFormat(
              item?.data?.inputs?.preferred_date,
              FORMAT_DD_MM_YYYY
            )}
          </Box>
        )}
        {getServiceCentreDetails() != item.service_centre_id && (
          <Box className={timeslot}>
            {convertDateTimeFormat(
              item?.data?.inputs?.preferred_date,
              FORMAT_DD_MM_YYYY
            )}
          </Box>
        )}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td}`} component="th" scope="row">
        {item?.id}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        <ClaimAmount item={item} />
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {item?.approved_amount
          ? `₹${Number(item?.approved_amount).toLocaleString("en")}`
          : item?.status.toLowerCase() === CLAIM_STATUS_REJECTED_SLUG
          ? "-"
          : PENDING_TEXT}
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${classes.inLine}`}>
        {`${convertDateTimeFormat(item?.created_at, FORMAT_DD_MM_YYYY)}`}
      </StyledTableCell>
      <StyledTableCell
        className={`${classes.tdAdditionalDetails}`}
        component="th"
        scope="row"
      >
        {item?.name} <br />
        {item?.mobile}
      </StyledTableCell>
      <StyledTableCell className={`${classes.tdAdditionalDetails}`} scope="row">
        <AdditionalDetails item={item} />
      </StyledTableCell>
      <StyledTableCell className={`${classes.td} ${item?.status}`}>
        <ClaimStatus item={item} handleRemarksClick={handleRemarksClick} />
      </StyledTableCell>
      <StyledTableCell className={classes.td} style={{ width: "10%" }}>
        <Box layout="row" display="flex">
          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_MOBILE_PHOTOS}
            downloadFile={downloadFile}
            item={item}
          />

          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_ESTIMATE}
            downloadFile={downloadFile}
            item={item}
          />

          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
            downloadFile={downloadFile}
            item={item}
          />

          <DownloadIcon
            documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
            downloadFile={downloadFile}
            item={item}
          />
        </Box>
        <Box layout="row" display="flex">
          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_MOBILE_PHOTOS}
            modalKey={SLUG_DAMAGED_MOBILE}
            text={BUTTON_UPLOAD_DAMAGED_MOBILE}
            uploadClickHandler={uploadClickHandler}
          />

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_ESTIMATE}
            modalKey={SLUG_ESTIMATE_MOBILE}
            text={BUTTON_ESTIMATE_CLAIM}
            uploadClickHandler={uploadClickHandler}
          />

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
            modalKey={SLUG_INVOICE_MOBILE}
            text={BUTTON_UPLOAD_INVOICE}
            uploadClickHandler={uploadClickHandler}
          />

          <ReUploadButton
            item={item}
            documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
            modalKey={SLUG_REPAIRED_MOBILE}
            text={BUTTON_UPLOAD_REPAIRED_MOBILE}
            uploadClickHandler={uploadClickHandler}
          />
        </Box>

        <Box layout="row" display="flex">
          {item?.status.toLowerCase() === CLAIM_STATUS_APPROVED_SLUG && (
            <Box layout="row" display="flex">
              <UploadButton
                documentTypeId={DOCUMENT_TPYE_ID_INVOICE}
                item={item}
                slug={SLUG_INVOICE_MOBILE}
                text={BUTTON_UPLOAD_INVOICE}
                tooltip={UPLOAD_REPAIRED_INVOICE_PHOTO}
                uploadClickHandler={uploadClickHandler}
              />

              <UploadButton
                documentTypeId={DOCUMENT_TPYE_ID_REPAIRED_MOBILE_PHOTOS}
                item={item}
                slug={SLUG_REPAIRED_MOBILE}
                text={BUTTON_UPLOAD_REPAIRED_MOBILE}
                tooltip={UPLOAD_REPAIRED_MOBILE_PHOTO}
                uploadClickHandler={uploadClickHandler}
              />
            </Box>
          )}
        </Box>

        {item?.status.toLowerCase().replace(" ", "_") ===
          CLAIM_STATUS_INITIATED_SLUG && (
          <Box layout="row" display="flex">
            {item.copayment_amount > 0 && (
              <Box>
                <Button
                  variant="outlined"
                  color={
                    isCopaymentSkippedForClaim(item.razorpay_order_id)
                      ? "primary"
                      : "secondary"
                  }
                  size={"small"}
                  className={`${borderRadius} ${marginLeft} ${capitalize}`}
                  data-tip={
                    isCopaymentSkippedForClaim(item.razorpay_order_id)
                      ? `Co-payment of ₹${Number(
                          item?.copayment_amount
                        ).toLocaleString(
                          "en"
                        )} need to collect from the customer`
                      : `Co-payment of ₹${Number(
                          item?.copayment_amount
                        ).toLocaleString("en")} already done`
                  }
                >
                  {isCopaymentSkippedForClaim(item.razorpay_order_id) && (
                    <CancelIcon style={{ margin: "3px 6px" }} />
                  )}
                  {!isCopaymentSkippedForClaim(item.razorpay_order_id) && (
                    <CheckCircleIcon
                      style={{ margin: "3px 6px", color: "green" }}
                    />
                  )}
                  {BUTTON_COPAY}
                </Button>
                <ReactTooltip />
              </Box>
            )}
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => handleEstimateClick(event, item)}
                data-tip={`Click to estimate this claim`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_ESTIMATE_CLAIM}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          </Box>
        )}

        {item.status_slug === CLAIM_STATUS_PARTIALLY_APPROVED &&
          (!item.repair_payment_successful && !item.repair_payment_link ? (
            <Box>
              <Button
                variant="contained"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                onClick={(event) => handlePaymentLinkClick(event, item)}
                data-tip={`Click to send repair partial payment link for this claim`}
              >
                <PaymentIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_LINK}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ) : (
            <Box>
              <Button
                variant="outlined"
                color="secondary"
                size={"small"}
                className={`${borderRadius} ${marginLeft} ${capitalize}`}
                data-tip={`Customer partial payment of Rs.${item.repair_amount} is pending`}
              >
                <DonutLargeIcon style={{ margin: "3px 6px" }} />
                {BUTTON_PAYMENT_PENDING}
              </Button>
              <ReactTooltip html={true} />
            </Box>
          ))}
      </StyledTableCell>
    </StyledTableRow>
  );
}

export default withStyles(useStyles, { withTheme: true })(ListItem);
